<div class="v-pageName">{{pageName}}</div>

<div class="body-main">
    <div class="qmig-card">
        <div class="qmig-card-body">
            <form class="form qmig-Form" [formGroup]="requestForm">
                <div class="row">
                    <div class="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3">
                        <div class="form-group">
                            <label class="form-label d-required" for="name">User Mail</label>
                            <input type="text" class="form-control"  disabled value="{{userMail}}">
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3">
                        <div class="form-group">
                            <label class="form-label d-required" for="name">Organization</label>
                            <select class="form-select" formControlName="organization" #org
                            (change)="getProjects(org.value)">
                                <option selected value="" default>Select Organization</option>
                                @for(orgList of orgData;track orgList){
                                <option value="{{orgList.organization}}">{{orgList.organization}}</option>
                                }
                            </select>
                            @if ( f.organization.touched && f.organization.invalid) {
                            <p class="text-start text-danger mt-1">
                                @if (f.organization.errors.required) {Organization is required. }
                            </p>
                            }
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 mt-4 pt-1"> 
                        <button
                            [disabled]="requestForm.invalid" (click)="requestAccess(requestForm.value)"
                            class="btn btn-upload w-100">Request Access
                            @if(spin_req){<app-spinner />}
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>